<!--  FORMULARIO EXPERIENCIA -->
<p class="text-form">Solamente los campos marcados con (*) son obligatorios.</p>
<form
  action=""
  autocomplete="off"
  class="form"
  [formGroup]="formStepMoreInformation"
>
  <!-- CURP -->
  <div>
    <mat-form-field appearance="fill" class="input-curp">
      <mat-label>CURP</mat-label>
      <input
        (keyup)="checkEvent()"
        matInput
        placeholder="Curp (XXXX000000(H|M)XXXXX00)"
        formControlName="curp"
        (keydown)="deleteSpaceInit($event)"
      />
      <div *ngIf="hideButton" matSuffix>
        <button
          mat-icon-button
          color="primary"
          aria-label="Example icon button with a home icon"
          (click)="isOpen = !isOpen"
          type="button"
          cdkOverlayOrigin
          #trigger="cdkOverlayOrigin"
        >
          <mat-icon>help</mat-icon>
        </button>
        <ng-template
          cdkConnectedOverlay
          [cdkConnectedOverlayOrigin]="trigger"
          [cdkConnectedOverlayOpen]="isOpen"
        >
          <p class="example-list">
            Si no recuerdas tu CURP búscalo desde
            <a href="http://www.gob.mx/curp/" target="_blank">aquí.</a>
          </p>
        </ng-template>
      </div>
      <mat-error
        *ngIf="
          formStepMoreInformation.controls['curp'].invalid &&
          formStepMoreInformation.controls['curp'].touched
        "
      >
        <span
          *ngIf="
            formStepMoreInformation.controls['curp'].errors &&
            formStepMoreInformation.controls['curp'].errors['required']
          "
          >Debe completar este campo</span
        >
      </mat-error>
      <mat-error
        *ngIf="formStepMoreInformation.controls['curp'].hasError('pattern')"
        >Formato incorrecto. (XXXX000000(H|M)XXXXX00)
      </mat-error>
    </mat-form-field>
  </div>
  <!-- EXPERIENCIA RECIENTE -->
  <mat-form-field appearance="fill">
    <mat-label>Experiencia reciente</mat-label>
    <mat-select
      (selectionChange)="checkEvent()"
      formControlName="experienceTypeCode"
    >
      <mat-option
        *ngFor="let experiencia of experienceTypes"
        [matTooltip]="experiencia.description"
        [matTooltipPosition]="'right'"
        [value]="experiencia.code"
      >
        {{ experiencia.description }}
      </mat-option>
    </mat-select>
    <mat-error
      *ngIf="
        formStepMoreInformation.controls['experienceTypeCode'].invalid &&
        formStepMoreInformation.controls['experienceTypeCode'].touched
      "
    >
      <span
        *ngIf="
          formStepMoreInformation.controls['experienceTypeCode'].errors &&
          formStepMoreInformation.controls['experienceTypeCode'].errors[
            'required'
          ]
        "
        >Debe completar este campo</span
      >
    </mat-error>
    <mat-error
      *ngIf="
        formStepMoreInformation.controls['experienceTypeCode'].hasError(
          'maxlength'
        )
      "
      >Máximo 16 caracteres.
    </mat-error>
  </mat-form-field>
  <!-- DONDE TRABAJAS -->
  <mat-form-field appearance="fill">
    <mat-label>¿Donde trabajas?</mat-label>
    <mat-select (selectionChange)="checkEvent()" formControlName="jobCityId">
      <mat-option
        *ngFor="let trabajo of jobCity"
        [value]="trabajo.id"
        (onSelectionChange)="validInputAnotherJobCity($event)"
      >
        {{ trabajo.name }}
      </mat-option>
    </mat-select>
    <mat-error
      *ngIf="
        formStepMoreInformation.controls['jobCityId'].invalid &&
        formStepMoreInformation.controls['jobCityId'].touched
      "
    >
      <span
        *ngIf="
          formStepMoreInformation.controls['jobCityId'].errors &&
          formStepMoreInformation.controls['jobCityId'].errors['required']
        "
        >Debe completar este campo</span
      >
    </mat-error>
    <mat-error
      *ngIf="
        formStepMoreInformation.controls['jobCityId'].hasError('maxlength')
      "
      >Máximo 45 caracteres.
    </mat-error>
  </mat-form-field>
  <!-- DONDE TRABAJAS(OTRA) -->
  <mat-form-field
    appearance="fill"
    *ngIf="
      formStepMoreInformation.get('jobCityId')!.value === 'OTR' ||
      formStepMoreInformation.get('jobCityId')!.value === 'Especifique'
    "
  >
    <mat-label>Otra(especifique)</mat-label>
    <input
      (keyup)="checkEvent()"
      matInput
      placeholder="Ingrese donde trabaja"
      formControlName="anotherJobCity"
    />
    <mat-error
      *ngIf="
        formStepMoreInformation.controls['anotherJobCity'].invalid &&
        formStepMoreInformation.controls['anotherJobCity'].touched
      "
    >
      <span
        *ngIf="
          formStepMoreInformation.controls['anotherJobCity'].errors &&
          formStepMoreInformation.controls['anotherJobCity'].errors['required']
        "
        >Debe completar este campo</span
      >
    </mat-error>
    <mat-error
      *ngIf="
        formStepMoreInformation.controls['anotherJobCity'].hasError('maxlength')
      "
      >Máximo 45 caracteres.
    </mat-error>
  </mat-form-field>
  <!-- DEPENDIENTES ECONOMICOS -->
  <mat-form-field
    appearance="fill"
    matTooltip="¿Cuántos dependientes económicos tienes?*"
  >
    <mat-label>¿Cuántos dependientes económicos tienes?</mat-label>
    <input
      appNumber
      (keyup)="checkEvent()"
      matInput
      placeholder="Ingrese cantidad de dependientes"
      formControlName="totalDependents"
    />
    <mat-error
      *ngIf="
        formStepMoreInformation.controls['totalDependents'].invalid &&
        formStepMoreInformation.controls['totalDependents'].touched
      "
    >
      <span
        *ngIf="
          formStepMoreInformation.controls['totalDependents'].errors &&
          formStepMoreInformation.controls['totalDependents'].errors['required']
        "
        >Debe completar este campo</span
      >
    </mat-error>
    <mat-error
      *ngIf="
        formStepMoreInformation.controls['totalDependents'].hasError(
          'maxlength'
        )
      "
      >Máximo 2 caracteres.
    </mat-error>
  </mat-form-field>
  <!-- GENERO -->
  <mat-form-field appearance="fill">
    <mat-label>Género</mat-label>
    <mat-select (selectionChange)="checkEvent()" formControlName="gender">
      <mat-option *ngFor="let gender of gender" [value]="gender.code">
        {{ gender.name }}
      </mat-option>
    </mat-select>
    <mat-error
      *ngIf="
        formStepMoreInformation.controls['gender'].invalid &&
        formStepMoreInformation.controls['gender'].touched
      "
    >
      <span
        *ngIf="
          formStepMoreInformation.controls['gender'].errors &&
          formStepMoreInformation.controls['gender'].errors['required']
        "
        >Debe completar este campo</span
      >
    </mat-error>
  </mat-form-field>
  <!-- PAIS NACIMIENTO -->
  <mat-form-field appearance="fill">
    <mat-label>País de nacimiento</mat-label>
    <mat-select
      (selectionChange)="checkEvent()"
      formControlName="countryOfBirthCode"
    >
      <mat-option
        *ngFor="let country of countries"
        [value]="country.code"
        (onSelectionChange)="selectionCountry(country.code, $event)"
      >
        {{ country.name }}
      </mat-option>
    </mat-select>
    <mat-error
      *ngIf="
        formStepMoreInformation.controls['countryOfBirthCode'].invalid &&
        formStepMoreInformation.controls['countryOfBirthCode'].touched
      "
    >
      <span
        *ngIf="
          formStepMoreInformation.controls['countryOfBirthCode'].errors &&
          formStepMoreInformation.controls['countryOfBirthCode'].errors[
            'required'
          ]
        "
        >Debe completar este campo</span
      >
    </mat-error>
    <mat-error
      *ngIf="
        formStepMoreInformation.controls['countryOfBirthCode'].hasError(
          'maxlength'
        )
      "
      >Máximo 50 caracteres.
    </mat-error>
  </mat-form-field>
  <!-- ESTADO NACIMIENTO -->
  <mat-form-field appearance="fill">
    <mat-label>Estado de nacimiento</mat-label>
    <mat-select
      (selectionChange)="checkEvent()"
      [formControl]="stateCtrl"
      placeholder="Estado"
      #singleSelect
    >
      <mat-option>
        <ngx-mat-select-search
          [formControl]="statesFilterCtrl"
          placeholderLabel="Buscar estado..."
          noEntriesFoundLabel="'Ningún estado con ese nombre'"
        >
        </ngx-mat-select-search>
      </mat-option>
      <mat-option
        *ngFor="let state of filteredStates | async"
        [value]="state.id"
      >
        {{ state.name }}
      </mat-option>
    </mat-select>
    <mat-error *ngIf="stateCtrl.invalid && stateCtrl.touched">
      <span *ngIf="stateCtrl.errors && stateCtrl.errors['required']"
        >Debe completar este campo</span
      >
    </mat-error>
  </mat-form-field>
  <!-- ESTADO CIVIL -->
  <mat-form-field appearance="fill">
    <mat-label>Estado civil</mat-label>
    <mat-select
      (selectionChange)="checkEvent()"
      formControlName="maritalStatus"
    >
      <mat-option
        *ngFor="let maritalStatus of maritalStatusList"
        [value]="maritalStatus.code"
      >
        {{ maritalStatus.name }}
      </mat-option>
    </mat-select>
    <mat-error
      *ngIf="
        formStepMoreInformation.controls['maritalStatus'].invalid &&
        formStepMoreInformation.controls['maritalStatus'].touched
      "
    >
      <span
        *ngIf="
          formStepMoreInformation.controls['maritalStatus'].errors &&
          formStepMoreInformation.controls['maritalStatus'].errors['required']
        "
        >Debe completar este campo</span
      >
    </mat-error>
  </mat-form-field>
  <!-- RFC -->
  <mat-form-field appearance="fill">
    <mat-label>RFC</mat-label>
    <input
      (keyup)="checkEvent()"
      matInput
      placeholder="Ingrese su rfc"
      formControlName="rfc"
      (keydown)="isLetterAndNumber($event)"
    />
    <mat-error
      *ngIf="
        formStepMoreInformation.controls['rfc'].invalid &&
        formStepMoreInformation.controls['rfc'].touched
      "
    >
      <span
        *ngIf="
          formStepMoreInformation.controls['rfc'].errors &&
          formStepMoreInformation.controls['rfc'].errors['required']
        "
        >Debe completar este campo</span
      >
    </mat-error>
    <mat-error
      *ngIf="formStepMoreInformation.controls['rfc'].hasError('pattern')"
      >Debe ingresar 13 caracteres.
    </mat-error>
  </mat-form-field>
  <!-- INE/IFE -->
  <mat-form-field appearance="fill">
    <mat-label>INE/IFE</mat-label>
    <input
      (keyup)="checkEvent()"
      matInput
      placeholder="Ingrese su INE/IFE"
      formControlName="ine"
      (keydown)="isLetterAndNumber($event)"
    />
    <mat-error
      *ngIf="
        formStepMoreInformation.controls['ine'].invalid &&
        formStepMoreInformation.controls['ine'].touched
      "
    >
      <span
        *ngIf="
          formStepMoreInformation.controls['ine'].errors &&
          formStepMoreInformation.controls['ine'].errors['required']
        "
        >Debe completar este campo</span
      >
    </mat-error>
    <mat-error
      *ngIf="formStepMoreInformation.controls['ine'].hasError('pattern')"
      >Debe ingresar 18 caracteres.
    </mat-error>
  </mat-form-field>
  <!-- NUMERO DE SEGURIDAD SOCIAL -->
  <mat-form-field appearance="fill">
    <mat-label>Número de seguridad social</mat-label>
    <input
      appNumber
      (keyup)="checkEvent()"
      matInput
      placeholder="Ingrese su número de seguridad social"
      formControlName="socialSecurityNumber"
      (keydown)="isLetterAndNumber($event)"
    />
    <mat-error
      *ngIf="
        formStepMoreInformation.controls['socialSecurityNumber'].invalid &&
        formStepMoreInformation.controls['socialSecurityNumber'].touched
      "
    >
      <span
        *ngIf="
          formStepMoreInformation.controls['socialSecurityNumber'].errors &&
          formStepMoreInformation.controls['socialSecurityNumber'].errors[
            'required'
          ]
        "
        >Debe completar este campo</span
      >
    </mat-error>
    <mat-error
      *ngIf="
        formStepMoreInformation.controls['socialSecurityNumber'].hasError(
          'pattern'
        )
      "
      >Debe ingresar 11 caracteres.
    </mat-error>
  </mat-form-field>
  <!-- OCUPACION -->
  <mat-form-field appearance="fill">
    <mat-label>Ocupación</mat-label>
    <mat-select (selectionChange)="checkEvent()" formControlName="occupationId">
      <mat-option
        *ngFor="let activity of activities"
        [value]="activity.id"
        (onSelectionChange)="validInputOtherOccupation($event)"
      >
        {{ activity.name }}
      </mat-option>
    </mat-select>
    <mat-error
      *ngIf="
        formStepMoreInformation.controls['occupationId'].invalid &&
        formStepMoreInformation.controls['occupationId'].touched
      "
    >
      <span
        *ngIf="
          formStepMoreInformation.controls['occupationId'].errors &&
          formStepMoreInformation.controls['occupationId'].errors['required']
        "
        >Debe completar este campo</span
      >
    </mat-error>
  </mat-form-field>
  <!-- OCUPACION(OTRA) -->
  <mat-form-field
    appearance="fill"
    *ngIf="formStepMoreInformation.get('occupationId')!.value == 32"
  >
    <mat-label>Otra(especifique)</mat-label>
    <input
      (keyup)="checkEvent()"
      matInput
      placeholder="Ingrese donde trabaja"
      formControlName="otherOccupation"
    />
    <mat-error
      *ngIf="
        formStepMoreInformation.controls['otherOccupation'].invalid &&
        formStepMoreInformation.controls['otherOccupation'].touched
      "
    >
      <span
        *ngIf="
          formStepMoreInformation.controls['otherOccupation'].errors &&
          formStepMoreInformation.controls['otherOccupation'].errors['required']
        "
        >Debe completar este campo</span
      >
    </mat-error>
    <mat-error
      *ngIf="
        formStepMoreInformation.controls['otherOccupation'].hasError(
          'maxlength'
        )
      "
      >Máximo 45 caracteres.
    </mat-error>
  </mat-form-field>
  <!-- CODIGO POSTAL -->
  <mat-form-field appearance="fill">
    <mat-label>Código postal</mat-label>
    <input
      appNumber
      (keyup)="checkEvent()"
      matInput
      placeholder="Ingrese código postal"
      formControlName="postalCodeId"
      (blur)="getPreviousPostalCode($event)"
    />
    <mat-error
      *ngIf="
        formStepMoreInformation.controls['postalCodeId'].invalid &&
        formStepMoreInformation.controls['postalCodeId'].touched
      "
    >
      <span
        *ngIf="
          formStepMoreInformation.controls['postalCodeId'].errors &&
          formStepMoreInformation.controls['postalCodeId'].errors['required']
        "
        >Debe completar este campo</span
      >
    </mat-error>
    <mat-error
      *ngIf="
        formStepMoreInformation.controls['postalCodeId'].hasError('pattern')
      "
      >Debe ingresar 5 caracteres.
    </mat-error>
  </mat-form-field>
  <!-- CALLE -->
  <mat-form-field appearance="fill">
    <mat-label>Calle</mat-label>
    <input
      (keyup)="checkEvent()"
      matInput
      placeholder="Ingrese calle"
      formControlName="street"
    />
    <mat-error
      *ngIf="
        formStepMoreInformation.controls['street'].invalid &&
        formStepMoreInformation.controls['street'].touched
      "
    >
      <span
        *ngIf="
          formStepMoreInformation.controls['street'].errors &&
          formStepMoreInformation.controls['street'].errors['required']
        "
        >Debe completar este campo</span
      >
    </mat-error>
    <mat-error
      *ngIf="formStepMoreInformation.controls['street'].hasError('maxlength')"
      >Máximo 50 caracteres.
    </mat-error>
  </mat-form-field>
  <!-- NUM. ext./Mz -->
  <mat-form-field appearance="fill">
    <mat-label>Num. ext./Mz</mat-label>
    <input
      (keyup)="checkEvent()"
      matInput
      placeholder="Ingrese Num. ext./Mz"
      formControlName="externalNumber"
    />
    <mat-error
      *ngIf="
        formStepMoreInformation.controls['externalNumber'].invalid &&
        formStepMoreInformation.controls['externalNumber'].touched
      "
    >
      <span
        *ngIf="
          formStepMoreInformation.controls['externalNumber'].errors &&
          formStepMoreInformation.controls['externalNumber'].errors['required']
        "
        >Debe completar este campo</span
      >
    </mat-error>
    <mat-error
      *ngIf="
        formStepMoreInformation.controls['externalNumber'].hasError('maxlength')
      "
      >Máximo 50 caracteres.
    </mat-error>
    <mat-error
      *ngIf="
        formStepMoreInformation.controls['externalNumber'].hasError('pattern')
      "
      >Debe ingresar solo letras y números.
    </mat-error>
  </mat-form-field>
  <!-- NUM. int./Lt. -->
  <mat-form-field appearance="fill">
    <mat-label>Num. int./Lt.</mat-label>
    <input
      (keyup)="checkEvent()"
      matInput
      placeholder="Ingrese um. int./Lt."
      formControlName="internalNumber"
    />
    <mat-error
      *ngIf="
        formStepMoreInformation.controls['internalNumber'].hasError('maxlength')
      "
      >Máximo 10 caracteres.
    </mat-error>
    <mat-error
      *ngIf="
        formStepMoreInformation.controls['internalNumber'].hasError('pattern')
      "
      >Debe ingresar solo letras y números.
    </mat-error>
  </mat-form-field>
  <!-- COLONIA -->
  <mat-form-field appearance="fill">
    <mat-label>Colonia</mat-label>
    <mat-select (selectionChange)="checkEvent()" formControlName="colonyId">
      <mat-option *ngFor="let option of colonies" [value]="option.id">
        {{ option.name }}
      </mat-option>
    </mat-select>
    <mat-error
      *ngIf="
        formStepMoreInformation.controls['colonyId'].invalid &&
        formStepMoreInformation.controls['colonyId'].touched
      "
    >
      <span
        *ngIf="
          formStepMoreInformation.controls['colonyId'].errors &&
          formStepMoreInformation.controls['colonyId'].errors['required']
        "
        >Debe completar este campo</span
      >
    </mat-error>
  </mat-form-field>
  <!-- ESTADO -->
  <mat-form-field appearance="fill">
    <mat-label>Estado</mat-label>
    <input
      (keyup)="checkEvent()"
      matInput
      placeholder="Ingrese estado"
      formControlName="stateId"
      readonly
    />
    <mat-error
      *ngIf="
        formStepMoreInformation.controls['stateId'].invalid &&
        formStepMoreInformation.controls['stateId'].touched
      "
    >
      <span
        *ngIf="
          formStepMoreInformation.controls['stateId'].errors &&
          formStepMoreInformation.controls['stateId'].errors['required']
        "
        >Debe completar este campo</span
      >
    </mat-error>
  </mat-form-field>
  <!-- ROTAR TURNOS -->
  <div>
    <mat-label>¿Tienes disponibildad para rotar turnos? *</mat-label>
    <div>
      <br />
      <mat-radio-group
        (change)="checkEvent()"
        aria-label="Select an option"
        formControlName="canRotateShift"
      >
        <mat-radio-button [value]="true" style="margin-right: 10px"
          >Si</mat-radio-button
        >
        <mat-radio-button [value]="false">No</mat-radio-button>
        <mat-error
          *ngIf="
            formStepMoreInformation.controls['canRotateShift'].invalid &&
            formStepMoreInformation.controls['canRotateShift'].touched
          "
        >
          <span
            *ngIf="
              formStepMoreInformation.controls['canRotateShift'].errors &&
              formStepMoreInformation.controls['canRotateShift'].errors[
                'required'
              ]
            "
            >Debe seleccionar una opción</span
          >
        </mat-error>
      </mat-radio-group>
    </div>
  </div>
</form>

<div class="container">
  <p>Agrega tus documentos o fotografías</p>
  <!-- TABLA IDENTIFICACIÓN -->
  <ng-container *ngFor="let option of documents">
    <table class="table">
      <thead>
        <tr>
          <th>
            <strong class="text-title-table"> {{ option.name }}</strong>
            (formatos permitidos .pdf, .jpg, .png, .rar)
          </th>
          <th></th>
        </tr>
      </thead>
      <tbody class="tBody">
        <tr *ngFor="let doc of option.documents">
          <td *ngIf="doc.required">{{ doc.name }}*</td>
          <td *ngIf="!doc.required">{{ doc.name }}</td>
          <td class="buttons-table-position">
            <ng-container *ngIf="doc.spinner; else publish">
              <mat-spinner [diameter]="20"></mat-spinner>
            </ng-container>
            <ng-template #publish>
              <ng-container *ngIf="!doc.uploaded; else uploaded">
                <label
                  mat-icon-button
                  matTooltip="Subir documento"
                  for="{{ doc.id }}"
                  style="color: #0ebc7f"
                >
                  <mat-icon> publish</mat-icon>
                </label>
                <input
                  type="file"
                  id="{{ doc.id }}"
                  name="avatar"
                  accept="image/png, image/jpeg, application/pdf, .rar"
                  hidden
                  (change)="saveDocument($event, doc)"
                />
              </ng-container>
              <ng-template #uploaded
                ><button
                  mat-icon-button
                  matTooltip="Ver documento"
                  color="primary"
                  (click)="viewDocuments(doc)"
                >
                  <mat-icon>remove_red_eye</mat-icon>
                </button>
                <button
                  mat-icon-button
                  matTooltip="Eliminar documento"
                  color="primary"
                  (click)="confirmDeleteDocuments(doc)"
                >
                  <mat-icon>delete</mat-icon>
                </button>
              </ng-template>
            </ng-template>
          </td>
        </tr>
      </tbody>
    </table>
  </ng-container>
</div>
